/**
 * Content Tables: Add data-label for mobile stack layout
 * Applies to .content-typography, #article-content-body, .rte, .page-content, .article-content
 */
(function() {
  function initTables() {
    var selectors = '.content-typography, #article-content-body, .rte, .page-content, .article-content';
    var containers = document.querySelectorAll(selectors);
    containers.forEach(function(container) {
      var tables = container.querySelectorAll('table');
      tables.forEach(function(table) {
        if (table.classList.contains('content-table-inited')) return;
        table.classList.add('content-table-inited', 'mobile-stack-table');
        var thead = table.querySelector('thead');
        var headers = [];
        if (thead && thead.rows.length > 0) {
          var ths = thead.rows[0].cells;
          for (var i = 0; i < ths.length; i++) {
            headers.push(ths[i].textContent.trim());
          }
        }
        var tbody = table.querySelector('tbody');
        if (tbody && headers.length > 0) {
          var rows = tbody.rows;
          for (var r = 0; r < rows.length; r++) {
            var cells = rows[r].cells;
            for (var c = 0; c < cells.length && c < headers.length; c++) {
              cells[c].setAttribute('data-label', headers[c]);
            }
          }
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTables);
  } else {
    initTables();
  }
})();
